import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert'; // Import

import CustomButton from './CustomButton';

export const confirmDialog = (
  message,
  action,
  optionalMessage,
  globalTranslations,
  actionNo
) => {
  const { Button, Title } = globalTranslations || {};

  const confirmAction = (onClose) => {
    action?.();
    onClose?.();
  };
  const cancelAction = (onClose) => {
    actionNo?.();
    onClose?.();
  };

  const additonalMessage = optionalMessage || '';

  confirmAlert({
    customUI: ({ onClose }) => (
      <Modal
        show={true}
        onHide={onClose}
        size={'s'}
        aria-labelledby="contained-modal-title-vcenter"
        centered={true}
        className={`second-modal clear-border-modal`}
        backdrop={'static'}
        scrollable
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>{Title?.confirmDialogTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col>{`${message}${additonalMessage}`}</Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end gap-3">
          <CustomButton
            size={`small`}
            label={Button.confirmAction}
            onClick={() => confirmAction(onClose)}
            startIcon={<i className="fa fa-check" />}
            className="default-btn-success"
          />
          <CustomButton
            size={`small`}
            label={Button.cancelAction}
            onClick={() => cancelAction(onClose)}
            startIcon={<i className="fa-solid fa-xmark"></i>}
            className={`default-btn-light`}
          />
        </Modal.Footer>
      </Modal>
    ),
  });
};
